import { LicenseStatuses } from "../../constants/licenses";
import { cn } from "../../lib/utils";

export function LicenseTechnicalStatus({ license, withBackground = true, ...props }) {
   if (!license) {
      return;
   }
   const status = LicenseStatuses[license.technicalStatus];

   return (
      <span className={cn("relative inline-flex flex-row items-center gap-2 font-semibold px-3! py-2!", props.className)} style={{ '--statusColor': status.color }}>
         {withBackground && (
            <span className="absolute z-10 size-full bg-(--statusColor)! opacity-10 inset-0 rounded-full"></span>
         )}
         <span className="relative z-20 block size-2 rounded-full bg-(--statusColor)"></span>
         <span className="relative z-20">{status.name}</span>
      </span>
   );
}